import { Outlet } from 'react-router-dom';
import TopNav from '../components/nav/TopNav.jsx';
import BottomTabBar from '../components/nav/BottomTabBar.jsx';
import { useAuth } from '../hooks/useAuth.js';

// Persistent chrome for every signed-in page. Top nav on desktop, bottom tab
// bar on mobile (CSS @media decides which one is visible — both mount).
export default function AppLayout() {
  const { isEmulating, viewAs, setViewAs } = useAuth();

  return (
    <div className="app">
      <TopNav />
      {isEmulating && (
        <div className="view-as-banner">
          <i className="ph ph-eye" />
          Previewing as <strong>{viewAs}</strong>. Server still returns admin-scoped data, so supervised-only surfaces (like the foreman crew roster) may render as if empty.
          <button onClick={() => setViewAs(null)}>Exit preview</button>
        </div>
      )}
      <main className="app-main app-main-spa">
        <Outlet />
      </main>
      <BottomTabBar />
    </div>
  );
}
